import PropTypes from "prop-types";
import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Menu, Button } from "@material-ui/core";
import ArrowDown from "@material-ui/icons/ExpandMore";

const DropdownButton = withStyles({
  root: {
    width: 335,
    height: 40,
    border: "0.2px solid #e0e0e0",
    borderRadius: 0,
    marginBottom: 10,
    padding: "5px 16px",
    marginTop: 25,
    fontSize: "1rem",
    fontWeight: 400,
    justifyContent: "space-between",
  },
})(Button);
const StyledMenu = withStyles((theme) => ({
  paper: {
    border: "1px solid #d3d4d5",
    borderRadius: 0,
    maxWidth: 335,
    width: 335,
    marginLeft: -4,
    [theme.breakpoints.up("xs")]: {
      marginLeft: -6,
    },
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 39,
      horizontal: 10,
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: 4,
    }}
    {...props}
  />
));
const useStyles = makeStyles({
  dropDownContainer: {
    padding: "15px 0",
  },
});

export default function DropDown(props) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className={classes.dropDownContainer}>
      <DropdownButton
        aria-controls="dropdown menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {props.label}
        <ArrowDown />
      </DropdownButton>
      <StyledMenu
        id="department"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {props.children}
      </StyledMenu>
    </div>
  );
}

DropDown.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
